import { OutlinedInput, type OutlinedInputProps as MuiOutlinedInputProps } from '@mui/material';
import { forwardRef } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiOutlinedInputProps, 'ref' | 'slots' | 'inputComponent' | 'inputProps'>>;

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never
// receive `ref`. Autocomplete anchors its options popper on this ref and renders no list without it.
export const Input = forwardRef<HTMLDivElement, Props>(function Input(props, ref) {
  return <OutlinedInput {...props} ref={ref} />;
});

export type { Props as InputProps };
